import React from 'react';

import { useSelector } from 'react-redux';

import { useNavigate, Link } from 'react-router-dom';

import { Card, Row, Col, Button } from 'react-bootstrap';

import { getDashboardStats } from '../services/dashboardService';
import { getActiveOrganizationId } from '../utils/organizations';

import DashboardDateRangeFilter from './dashboard/DashboardDateRangeFilter';
import DashboardStatCard from './dashboard/DashboardStatCard';



function Dashboard() {

  const { user } = useSelector((state) => state.auth);

  const navigate = useNavigate();

  const activeOrganizationId = getActiveOrganizationId(user);

  const isOrgAdmin = Boolean(
    user?.is_organization_admin ?? user?.is_organization_owner
  );

  const [dateRange, setDateRange] = React.useState({

    preset: 'all_time',

    startDate: '',

    endDate: '',

    query: {},

  });

  const [stats, setStats] = React.useState({

    draft_envelopes: 0,

    action_required: 0,

    sent_envelopes: 0,

    completed_envelopes: 0,

    saved_templates: 0,

    organization_users: null,

  });

  const [loadingStats, setLoadingStats] = React.useState(true);



  React.useEffect(() => {

    let alive = true;

    const loadStats = async () => {

      setLoadingStats(true);

      try {

        const data = await getDashboardStats(dateRange.query || {});

        if (!alive) return;

        setStats((prev) => ({

          ...prev,

          ...(data?.stats || {}),

        }));

      } catch (error) {

        if (!alive) return;

      } finally {

        if (alive) setLoadingStats(false);

      }

    };

    loadStats();

    return () => {

      alive = false;

    };

  }, [dateRange, activeOrganizationId]);



  const statusCards = [

    { label: 'Draft envelopes', count: stats.draft_envelopes ?? 0, icon: 'ri-file-edit-line', color: 'primary' },

    { label: 'Sent envelopes', count: stats.sent_envelopes ?? 0, icon: 'ri-send-plane-line', color: 'info' },

    { label: 'Completed envelopes', count: stats.completed_envelopes ?? 0, icon: 'ri-checkbox-circle-line', color: 'success' },

    { label: 'Action required', count: stats.action_required ?? 0, icon: 'ri-alert-line', color: 'warning' },

    { label: 'Saved templates', count: stats.saved_templates ?? 0, icon: 'ri-file-list-3-line', color: 'secondary' },

    ...(stats.organization_users == null

      ? []

      : [{ label: 'Organization users', count: stats.organization_users ?? 0, icon: 'ri-team-line', color: 'dark' }]),

  ];



  return (

    <div className="dashboard-page">

      <div className="welcome-section mb-4 d-flex flex-wrap gap-3 align-items-center justify-content-between">

        <h2 className="welcome-title mb-0">Welcome back, {user?.name || 'User'}</h2>

      </div>



      <Card className="dashboard-date-range-card mb-4">

        <Card.Body>

          <DashboardDateRangeFilter

            value={dateRange}

            disabled={loadingStats}

            onChange={setDateRange}

          />

        </Card.Body>

      </Card>



      <Row className="mb-4 g-3">

        {statusCards.map((card, index) => (

          <Col key={index} md={4}>

            <DashboardStatCard
              label={card.label}
              value={card.count}
              icon={card.icon}
              color={card.color}
              loading={loadingStats}
            />

          </Col>

        ))}

      </Row>



      <div className="action-bar d-flex align-items-center justify-content-between mb-4">

        <div className="d-flex align-items-center gap-3">

          {isOrgAdmin && (
            <Link to="/team-dashboard" className="text-decoration-none text-primary">
              Team dashboard <i className="ri-arrow-right-line ms-1"></i>
            </Link>
          )}

        </div>

        <Button variant="success" className="d-flex align-items-center">

          <i className="ri-add-line me-2"></i>

          Document

          <i className="ri-arrow-down-s-line ms-2"></i>

        </Button>

      </div>



      <div className="create-document-section">

        <Card className="create-card">

          <Card.Body className="text-center py-5">

            <div className="document-icon-wrapper mb-4">

              <div className="document-icon">

                <i className="ri-file-add-line"></i>

              </div>

            </div>



            <h4 className="mb-3">Start here — or pick up where you left off</h4>

            <p className="text-muted mb-4">

              Create your first envelope, or return here to continue with any unsent envelopes.

            </p>



            <Button

              variant="success"

              size="lg"

              className="create-document-btn"

              onClick={() => navigate('/create-envelope')}

            >

              <i className="ri-add-line me-2"></i>

              Create Envelope

            </Button>

          </Card.Body>

        </Card>

      </div>

    </div>

  );

}



export default Dashboard;


